import React, { useState } from 'react'

import { Text } from 'marketing-site/src/library/elements/Text'
import { mq } from 'marketing-site/src/library/utils'
import { HeaderNavigationMenuItem } from './HeaderNavigationMenuItem'
import { IHeaderNavigationMenuItem, IHeaderNavigationMenuSection } from '..'
import { useIsomorphicLayoutEffect } from 'marketing-site/src/library/hooks/useIsomorphicLayoutEffect'

export function HeaderNavigationMenuSection({
  contentType = 'flex',
  theme = 'light',
  title,
  items,
  itemsSecondColumn,
}: IHeaderNavigationMenuSection): React.ReactElement {
  const [headerNavigationMenuItems, setHeaderNavigationMenuItems] =
    useState<IHeaderNavigationMenuItem[]>()

  const [headerNavigationMenuSecondItems, setHeaderNavigationMenuSecondItems] =
    useState<IHeaderNavigationMenuItem[]>()

  useIsomorphicLayoutEffect(() => {
    items && setHeaderNavigationMenuItems(items)

    itemsSecondColumn && setHeaderNavigationMenuSecondItems(itemsSecondColumn)
  }, [setHeaderNavigationMenuItems, setHeaderNavigationMenuSecondItems])

  return (
    <>
      <div className="header-navigation-section" role="menu" aria-label={title}>
        {title && (
          <div className="header-navigation-section__title">
            <Text
              brand={contentType === 'flex' ? 'default' : 'mvp'}
              size={contentType === 'flex' ? 'eyebrows' : 'eyebrow'}
            >
              {title}
            </Text>
          </div>
        )}
        <div className="header-navigation-section__items">
          <div className="header-navigation-section__items-column">
            {headerNavigationMenuItems &&
              headerNavigationMenuItems.map((item) => {
                return (
                  <HeaderNavigationMenuItem
                    key={item.title}
                    {...item}
                    contentType={contentType}
                    theme={theme}
                  />
                )
              })}
          </div>
          {headerNavigationMenuSecondItems && (
            <div className="header-navigation-section__items-column">
              {headerNavigationMenuSecondItems.map((item) => {
                return (
                  <HeaderNavigationMenuItem
                    key={item.title}
                    {...item}
                    contentType={contentType}
                    theme={theme}
                  />
                )
              })}
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
        .header-navigation-section {
          &__title {
            margin-bottom: 1.25rem;
            text-transform: uppercase;
            transition: color 0.32s;
          }

          &__items {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 1.25rem;
          }

          &__items-column {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: start;
            row-gap: 1.25rem;
          }
        }

        @media (${mq.desktop}) {
          .header-navigation-section {
            flex: 1;

            &__title {
              margin-bottom: 1.25rem;
            }

            &__items {
              flex-direction: row;
              gap: 2rem;
            }

            &__items-column {
              flex-direction: column;
              gap: 1.5rem;
            }
          }
        }
      `}</style>
    </>
  )
}
